(function() {
    angular
        .module("app")
        .controller("MetaController", MetaController)

    MetaController.$inject = ["$scope", "metaService"]

    function MetaController($scope, metaService) {
        "use strict"

        /**
            $scope variables
         **/
        $scope.meta = metaService
    }
})()
